import React from 'react';
import { BatchHistoryPanel } from '../components/inventory/BatchHistoryPanel';
import { InventorySectionNav } from '../components/inventory/InventorySectionNav';
import { colors, spacing, typography, typographyFlat } from '../styles/tokens';

export const InventoryHistoryPage: React.FC = () => {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Batch History</h1>
        <p style={styles.subtitle}>
          Browse submitted intake batches and re-sync their variants to selected channels.
        </p>
        <InventorySectionNav />
      </div>

      <BatchHistoryPanel />
    </div>
  );
};

const styles = {
  container: {
    padding: spacing.xl,
  },
  header: {
    marginBottom: spacing.lg,
  },
  title: {
    margin: 0,
    fontSize: typography.h1.fontSize,
    fontWeight: typography.h1.fontWeight,
    color: colors.text,
  },
  subtitle: {
    margin: `${spacing.sm} 0 0`,
    fontSize: typographyFlat.fontSize.lg,
    color: colors.textSecondary,
  },
};

export default InventoryHistoryPage;
